/* This is added to fix datatable first column cellData returned value not getting displayed */
function dummyColumn() {
  return {
    label_of_column: '',
    name_of_db_column: '-',
    order_of_column: -1,
    initialSize: 0,
    maxSize: 0,
    minSize: 0,
    cellData: () => {},
  }
}

function getMappedCellData(columns) {
  return [dummyColumn(), ...columns]
}

export {getMappedCellData}
